import { Block, BlockSchema } from './Block.types';

import { FooterBlockConfigSchema, BlockType } from './blockConfig/Types';

import z from 'zod';

export const FooterBlockSchema = BlockSchema.extend({
  blockConfig: FooterBlockConfigSchema,
});

export type FooterBlock = z.infer<typeof FooterBlockSchema>;

export function isFooterBlock(block: Block): block is FooterBlock {
  return block.blockConfig.type === BlockType.Footer;
}
